import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import LatestUpdates from "./latestupdates";
import "./img.css";
import { motion } from "framer-motion";
import { Container, Row, Col, Card, ListGroup, Button, Image, Table } from "react-bootstrap";
import { FaFacebook, FaTiktok, FaYoutube, FaInstagram } from "react-icons/fa";
import Footer from "./footer";

const HeroSection = () => (
  <div className="bg-light p-4 text-center">
    <h1 className="fw-bold">Skilled Independent Visa (Subclass 189)</h1>
  </div>
);

const ContentSection = () => (
  <Col xs={12} md={8} className="mb-4">
    <p>
      This visa is for invited workers and New Zealand citizens with skills we need,
      to live and work permanently anywhere in Australia.
    </p>
    <h4>BASIC ELIGIBILITY</h4>
    <p>Eligibility varies based on the relating stream.</p>
    <p>For the points tested stream:</p>
    <ul>
      <li>You don’t need a sponsor or nominator</li>
      <li>You must be invited to apply</li>
      <li>You must be under 45 to be invited</li>
    </ul>
    <p>For the New Zealand Stream:</p>
    <ul>
      <li>You must hold a New Zealand Special Category (subclass 444) visa</li>
      <li>You must have lived in Australia for at least the last 5 years</li>
      <li>You must have stAATed living here on or before 19 February 2016</li>
    </ul>
    <h4>WHAT YOU CAN DO</h4>
    <p>This visa allows you to:</p>
    <ul>
      <li>Stay in Australia for the period that aligns with your approved activities.</li>
      <li>Do work or activity specified in your application.</li>
      <li>Enter and leave Australia as many times as you want while your visa is valid.</li>
      <li>If eligible, become an Australian Citizen.</li>
      <li>Sponsor eligible relatives for permanent residence.</li>
    </ul>
    <h4>VISA STREAMS</h4>

    <motion.button
      initial={{ x: "-100vw", opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      transition={{ type: "tween", duration: 0.6, ease: "easeOut" }}
      className="btn btn-danger btn-sm position-fixed bottom-0 stAAT-0 m-3"
      style={{ zIndex: 1050 }}
    >
      <a 
        href="https://au.bajwaimmigration.com/book-appointment" 
        className="text-white text-decoration-none"
      >
        Consult Now
      </a>
    </motion.button>

    <VisaTable />
  </Col>
);

const Sidebar = () => (
    <Col md={3}>
       <Col md={12}>
    <div style={{ maxWidth: "800px", width: "100%" }}>
        <Card className="border-0 shadow-none">
        <Card.Header className="fw-bold">Latest Posts</Card.Header>
            <ListGroup variant="flush">
                <ListGroup.Item className="border-0"><Link to="/professional" className="dropdown-item"> <a href="" className="text-decoration-none">Professional Year</a> </Link></ListGroup.Item>
                <ListGroup.Item className="border-0"><Link to="/coursechange" className="dropdown-item"> <a href="" className="text-decoration-none">Admissions And Course Change </a></Link></ListGroup.Item>
                <ListGroup.Item className="border-0"><Link to="/skilledID" className="dropdown-item"> <a href="" className="text-decoration-none">Skilled Independent Visa (Subclass 189)</a></Link></ListGroup.Item>
                <ListGroup.Item className="border-0"><Link to="/workregionalvisa" className="dropdown-item"> <a href="" className="text-decoration-none">Skilled Work Regional Visa (Subclass 491)</a></Link></ListGroup.Item>
                <ListGroup.Item className="border-0"><Link to="/nominatedvisa" className="dropdown-item"> <a href="" className="text-decoration-none">Skilled Nominated Visa (Subclass 190)</a></Link></ListGroup.Item>
                 <ListGroup.Item><a href="https://immi.homeaffairs.gov.au/visas/getting-a-visa/visa-listing/skilled-regional-191"className="dropdown-item text-decoration-none"style={{ color: "#22327f" }}target="_blank"rel="noopener noreferrer">Permanent Residence visa (Subclass 191)</a></ListGroup.Item>
                                {/* <ListGroup.Item><Link to="/regionalvisa" className="dropdown-item"><a href="" className="text-decoration-none">Skilled Regional Visa (Subclass 887)</a></Link></ListGroup.Item> */
                                <ListGroup.Item><Link to="/tempactivity" className="dropdown-item"><a href="" className="text-decoration-none">Temporary Activity Visa (Subclass 408)</a></Link></ListGroup.Item>
}
                            </ListGroup>
        </Card>
    </div>
</Col>


                  

        {/* YouTube & Social Media Section */}
        <Card className="p-3 text-center mt-4"> {/* Added spacing between sidebar and card */}
            <Image src="./img/brand-logo.png" alt="Bajwa Immigration Logo" fluid className="mb-3" />

            <h6 className="fw-bold">Subscribe to our YouTube channel</h6>
            <Button variant="danger" className="mb-3"><a href="https://www.youtube.com/embed/uOGAB9oYets" >SUBSCRIBE </a></Button>

            <h6 className="fw-bold">Book Consultation</h6>
            <Button variant="warning">BOOK CONSULTATION</Button>

            <h6 className="fw-bold mt-3">Like Us on Facebook !!</h6>
            <iframe
                src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FBajwaImmigration&tabs&width=340&height=130&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
                width="100%"
                height="130"
                style={{ border: "none", overflow: "hidden" }}
                scrolling="no"
                frameBorder="0"
                allowFullScreen
            ></iframe>

            <h6 className="fw-bold mt-3">We are also on:</h6>
            <div className="d-flex justify-content-center gap-3">
                <FaInstagram size={30} color="#C13584" />
                <FaTiktok size={30} color="#000" />
                <FaYoutube size={30} color="crimson" />
            </div>
        </Card>
    </Col>
);

const VisaTable = () => (
    <div className="mt-4 table-responsive">
        <Table bordered hover className="table">
            <thead className="table">
                <tr>
                    <th>TYPE</th>
                    <th>DESCRIPTION</th>
                    <th>STAY</th>
                    <th>COST</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td><strong>Points Tested Stream</strong></td>
                    <td>This visa lets invited workers with skills we need live and work permanently anywhere in Australia.</td>
                    <td>This is a permanent visa. It lets you stay in Australia indefinitely.</td>
                    <td>The visa costs AUD4,045 for the main applicant. There is also a charge for each family member who applies for the visa with you.</td>
                </tr>
                <tr>
                    <td><strong>New Zealand Stream</strong></td>
                    <td>This visa lets eligible New Zealand citizens who have demonstrated commitment and contribution to Australia, live and work in Australia permanently.</td>
                    <td>This is a permanent visa. It lets you stay in Australia indefinitely. Hong Kong passport holders may stay for 5 years.</td>
                    <td>From AUD4,045, for the main applicant. The visa application charge is paid in two installments.</td>
                </tr>
            </tbody>
        </Table>
    </div>
);

const SkilledId = () => (
  <>
    <Container className="mt-4">
      <HeroSection />
      <Row className="mt-4 gap-4">
        <ContentSection />
        <Sidebar />
      </Row>
    </Container>
    <LatestUpdates />
    <Footer />
  </>
);

export default SkilledId;